
type Props = {
    count: number;
    totalCount: number;
    currentPage: number;
    onPageChange: (page: number) => void;
};

export default function Paginator({
    count,
    totalCount,
    currentPage,
    onPageChange,
}: Props) {
    const totalPages = Math.max(1, Math.ceil(totalCount / count));

    const getPages = (): (number | string)[] => {
        if (totalPages <= 5) {
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        }

        const pages: (number | string)[] = [];

        pages.push(1);

        if (currentPage <= 3) {
            pages.push(2, 3, 4, "…", totalPages);
            return pages;
        }
        if (currentPage >= totalPages - 2) {
            pages.push("…", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            return pages;
        }
        pages.push("…", currentPage - 1, currentPage, currentPage + 1, "…", totalPages);

        return pages;
    };

    const pages = getPages();
    const start = totalCount === 0 ? 0 : (currentPage - 1) * count + 1;
    const end = Math.min(currentPage * count, totalCount);

    return (
        <div className="pagination-ui">
            <div className="pager">
                Showing Results {start} - {end} of {totalCount}
            </div>

            <div className="pagination" >
                {pages.map((p, idx) =>
                    p === "…" ? (
                        <button key={`dots-${idx}`} disabled style={{ cursor: "default" }}>…</button>
                    ) : (
                        <button
                            key={p}
                            className={p === currentPage ? "active" : ""}
                            onClick={() => onPageChange(p as number)}
                        >
                            {p}
                        </button>
                    )
                )}
            </div>
        </div>
    );
}
